import { Injectable } from '@angular/core';
import { AuthenticationService } from "../authentication.service";
import { Http } from "@angular/http";
@Injectable()
export class RestRecipeService {

  constructor(private auth: AuthenticationService, private http: Http) { }

  GetRecipe(filterData: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Recipe",
        filterData,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  SaveRecipe(Recipe_Master: any) {
    if (Recipe_Master.RecipeId == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Save_Recipe",
          Recipe_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {

      return this.http
        .put(
          this.auth.baseUrl + "/services/api/rest/v1/Update_Recipe",
          Recipe_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }

  }

  UpdateRecipe(Recipe_Master: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Update_Recipe",
        Recipe_Master,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });


  }
  GetModifiersByBarCode(customDataFilter: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Modifiers_ByBarCode",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetRecipeById(customDataFilter: any) {

    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Recipe_ByItemId",
        customDataFilter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }


}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/restaurant/rest-recipe.service.ts